import { createSlice } from '@reduxjs/toolkit';

import { loadingInitialState } from './state';
const COUNT_UNIT = 1;
const COUNT_MINIMUM = 0;
export const loadingSlice = createSlice({
  name: 'loading',
  initialState: loadingInitialState,
  reducers: {
    showLoading: (state) => {
      state.active = true;
      return state;
    },
    hideLoading: (state) => {
      state.active = false;
      return state;
    },

    incrementLoadingCount: (state) => {
      state.count += COUNT_UNIT;
      if (state.count > COUNT_MINIMUM) {
        state.active = true;
      }
      return state;
    },
    decrementLoadingCount: (state) => {
      if (state.count > COUNT_MINIMUM) {
        state.count -= COUNT_UNIT;
      }

      if (state.count === COUNT_MINIMUM) {
        state.active = false;
      }

      return state;
    },
  },
});
